import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { AuthPage } from "@/client/components/auth/auth-page";
import { SignInForm } from "@/client/components/auth/sign-in-form";
import { useSession } from "@/client/hooks/use-session";
import { safeReturnTo } from "@/client/lib/auth-redirect";

export const Route = createFileRoute("/signin")({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } =>
    ({ redirect: safeReturnTo(search.redirect ?? search.returnTo) }),
  component: SignIn,
});

function SignIn() {
  const { status } = useSession();
  const { redirect } = Route.useSearch();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === "signed-in") void navigate({ href: redirect ?? "/", replace: true });
  }, [status, navigate, redirect]);

  return (
    <AuthPage
      title="Sign in"
      description="Accounts are created by the administrator. Ask them for a setup link if you don't have one."
    >
      <SignInForm />
    </AuthPage>
  );
}
